module.exports = __webpack_public_path__ + "static/img/边8.7cbf4ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/边8.png
// module id = sKJM
// module chunks = 2